function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Return true if `value` is object-like. A value is object-like if it's not
 * `null` and has a `typeof` result of "object".
 */
export default function isObjectLike(value) {
  return _typeof(value) == 'object' && value !== null;
}



//////////////////
// WEBPACK FOOTER
// ./~/graphql/jsutils/isObjectLike.mjs
// module id = Sp/Z
// module chunks = 9